import { render, staticRenderFns } from "./editGbody100.vue?vue&type=template&id=67dc0b28&"
import script from "./editGbody100.vue?vue&type=script&lang=js&"
export * from "./editGbody100.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports